// SUMMARY_INVOICE_LIST
export const SUMMARY_INVOICE_LIST = "SUMMARY_INVOICE_LIST";
export const SUMMARY_INVOICE_LIST_SUCCESS = "SUMMARY_INVOICE_LIST_SUCCESS";
export const SUMMARY_INVOICE_LIST_FAIL = "SUMMARY_INVOICE_LIST_FAIL";
export const SUMMARY_INVOICE_LIST_RESET = "SUMMARY_INVOICE_LIST_RESET";

export const SET_COLUMN_VISIBLE_SUMMARY_INVOICE_LIST =
  " SET_COLUMN_VISIBLE_SUMMARY_INVOICE_LIST";

// RELEASE_INVOICE_CYCLES
export const RELEASE_INVOICE_CYCLES = "RELEASE_INVOICE_CYCLES";
export const RELEASE_INVOICE_CYCLES_SUCCESS = "RELEASE_INVOICE_CYCLES_SUCCESS";
export const RELEASE_INVOICE_CYCLES_FAIL = "RELEASE_INVOICE_CYCLES_FAIL";
export const RESET_RELEASE_INVOICE_CYCLES = "RESET_RELEASE_INVOICE_CYCLES";

// CREATE_INVOICE_CYCLES
export const CREATE_INVOICE_CYCLES = "CREATE_INVOICE_CYCLES";
export const CREATE_INVOICE_CYCLES_SUCCESS = "CREATE_INVOICE_CYCLES_SUCCESS";
export const CREATE_INVOICE_CYCLES_FAIL = "CREATE_INVOICE_CYCLES_FAIL";
export const RESET_CREATE_INVOICE_CYCLES = "RESET_CREATE_INVOICE_CYCLES";

// LIST_INVOICE_TO_SUMMARY
export const LIST_INVOICE_TO_SUMMARY = "LIST_INVOICE_TO_SUMMARY";
export const LIST_INVOICE_TO_SUMMARY_SUCCESS =
  "LIST_INVOICE_TO_SUMMARY_SUCCESS";
export const LIST_INVOICE_TO_SUMMARY_FAIL = "LIST_INVOICE_TO_SUMMARY_FAIL";
export const RESET_LIST_INVOICE_TO_SUMMARY = "RESET_LIST_INVOICE_TO_SUMMARY";

// LIST_KHDD_INVOICE_TO_SUMMARY
export const LIST_KHDD_INVOICE_TO_SUMMARY = "LIST_KHDD_INVOICE_TO_SUMMARY";
export const LIST_KHDD_INVOICE_TO_SUMMARY_SUCCESS =
  "LIST_KHDD_INVOICE_TO_SUMMARY_SUCCESS";
export const LIST_KHDD_INVOICE_TO_SUMMARY_FAIL =
  "LIST_KHDD_INVOICE_TO_SUMMARY_FAIL";
export const RESET_LIST_KHDD_INVOICE_TO_SUMMARY =
  "RESET_LIST_KHDD_INVOICE_TO_SUMMARY";

//TRANSFER_USB_INVOICE_CYCLES
export const TRANSFER_USB_INVOICE_CYCLES = "TRANSFER_USB_INVOICE_CYCLES";
export const TRANSFER_USB_INVOICE_CYCLES_SUCCESS =
  "TRANSFER_USB_INVOICE_CYCLES_SUCCESS";
export const TRANSFER_USB_INVOICE_CYCLES_FAIL =
  "TRANSFER_USB_INVOICE_CYCLES_FAIL";
export const RESET_TRANSFER_USB_INVOICE_CYCLES =
  "RESET_TRANSFER_USB_INVOICE_CYCLES";

// REPORT_INVOICE_LIST
export const REPORT_INVOICE_LIST = "REPORT_INVOICE_LIST";
export const REPORT_INVOICE_LIST_SUCCESS = "REPORT_INVOICE_LIST_SUCCESS";
export const REPORT_INVOICE_LIST_FAIL = "REPORT_INVOICE_LIST_FAIL";
export const REPORT_INVOICE_LIST_RESET = "REPORT_INVOICE_LIST_RESET";

// GET_REPORT_INVOICE_PROGRESS
export const GET_REPORT_INVOICE_PROGRESS = "GET_REPORT_INVOICE_PROGRESS";
export const GET_REPORT_INVOICE_PROGRESS_SUCCESS =
  "GET_REPORT_INVOICE_PROGRESS_SUCCESS";
export const GET_REPORT_INVOICE_PROGRESS_FAIL =
  "GET_REPORT_INVOICE_PROGRESS_FAIL";
export const RESET_GET_REPORT_INVOICE_PROGRESS =
  "RESET_GET_REPORT_INVOICE_PROGRESS";

// DOWNLOAD_REPORT_INVOICE
export const DOWNLOAD_REPORT_INVOICE = "DOWNLOAD_REPORT_INVOICE";
export const DOWNLOAD_REPORT_INVOICE_SUCCESS =
  "DOWNLOAD_REPORT_INVOICE_SUCCESS";
export const DOWNLOAD_REPORT_INVOICE_FAIL = "DOWNLOAD_REPORT_INVOICE_FAIL";
export const RESET_DOWNLOAD_REPORT_INVOICE = "RESET_DOWNLOAD_REPORT_INVOICE";

// CREATE_REPORT_INVOICE
export const CREATE_REPORT_INVOICE = "CREATE_REPORT_INVOICE";
export const CREATE_REPORT_INVOICE_SUCCESS = "CREATE_REPORT_INVOICE_SUCCESS";
export const CREATE_REPORT_INVOICE_FAIL = "CREATE_REPORT_INVOICE_FAIL";
export const RESET_CREATE_REPORT_INVOICE = "RESET_CREATE_REPORT_INVOICE";

export const SET_COLUMN_VISIBLE_REPORT_INVOICE_LIST =
  " SET_COLUMN_VISIBLE_REPORT_INVOICE_LIST";

// EXECUTE_REPORT
export const EXECUTE_REPORT = "EXECUTE_REPORT";
export const EXECUTE_REPORT_SUCCESS = "EXECUTE_REPORT_SUCCESS";
export const EXECUTE_REPORT_FAIL = "EXECUTE_REPORT_FAIL";
export const RESET_EXECUTE_REPORT = "RESET_EXECUTE_REPORT";

// GET_REPORT_LOG
export const GET_REPORT_LOG = "GET_REPORT_LOG";
export const GET_REPORT_LOG_SUCCESS = "GET_REPORT_LOG_SUCCESS";
export const GET_REPORT_LOG_FAIL = "GET_REPORT_LOG_FAIL";
export const RESET_GET_REPORT_LOG = "RESET_GET_REPORT_LOG";
